import "./QrCorners.css";

// The one signature device this page repeats, on purpose, in exactly two
// places (hero phone, featured pricing card): a QR finder-pattern corner
// bracket, pulled straight from the Tablify mark itself. Everything else
// on the page stays quiet so this reads as deliberate, not decorative.
function QrCorners({ tone = "gold", className = "" }) {
  return (
    <div className={`qr-corners qr-corners-${tone} ${className}`} aria-hidden="true">
      <span className="qr-corner qr-corner-tl" />
      <span className="qr-corner qr-corner-tr" />
      <span className="qr-corner qr-corner-bl" />
      <span className="qr-corner qr-corner-br" />
    </div>
  );
}

export default QrCorners;
